function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { AdBreakSource, AdBreakUpdateMergeStrategy } from '../../../addons/adverts/common';
import { sdkLogger } from '../../../logger';
import { Observable } from '../../../utils/observables/observable';
export { MetadataType } from '../../aamp/aamp.enums';
export var BaseSsaiAdBreaksProvider = /*#__PURE__*/ function() {
    "use strict";
    function BaseSsaiAdBreaksProvider() {
        _class_call_check(this, BaseSsaiAdBreaksProvider);
        _define_property(this, "ssaiStitcherType", void 0);
        _define_property(this, "resolveAdBreaksPromise", void 0);
        _define_property(this, "adBreakDataReceivedObservable", new Observable());
        _define_property(this, "telemetryUpdateObservable", new Observable());
        _define_property(this, "partialBreakDataObservable", new Observable());
        _define_property(this, "errorObservable", new Observable());
        _define_property(this, "playoutData", void 0);
    }
    _create_class(BaseSsaiAdBreaksProvider, [
        {
            key: "setPlayoutData",
            value: function setPlayoutData(playoutData) {
                this.playoutData = playoutData;
            }
        },
        {
            key: "onAdBreakDataReceived",
            value: function onAdBreakDataReceived(listener) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, config = arguments.length > 2 ? arguments[2] : void 0;
                this.adBreakDataReceivedObservable.registerObserver(listener.bind(context), context, config ? {
                    renotifyLastEvent: config.renotifyLast
                } : undefined);
            }
        },
        {
            key: "onTelemetryUpdateReceived",
            value: function onTelemetryUpdateReceived(listener) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                this.telemetryUpdateObservable.registerObserver(listener.bind(context), context);
            }
        },
        {
            key: "onPartialBreakDataReceived",
            value: function onPartialBreakDataReceived(listener) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                this.partialBreakDataObservable.registerObserver(listener.bind(context), context);
            }
        },
        {
            key: "onError",
            value: function onError(listener) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                this.errorObservable.registerObserver(listener.bind(context), context);
            }
        },
        {
            key: "disable",
            value: function disable() {
                sdkLogger.warn('AdBreaks Provider has been disabled - Now notifying that there are no ad breaks');
                this.adBreakDataReceivedObservable.notifyObservers({
                    adBreaks: [],
                    source: AdBreakSource.Unpaginated,
                    mergeStrategy: AdBreakUpdateMergeStrategy.Overwrite
                });
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners() {
                var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                this.adBreakDataReceivedObservable.unregisterObservers(context);
                this.telemetryUpdateObservable.unregisterObservers(context);
                this.partialBreakDataObservable.unregisterObservers(context);
                this.errorObservable.unregisterObservers(context);
            }
        },
        {
            key: "notifyAdBreakDataReceived",
            value: function notifyAdBreakDataReceived(adBreakUpdate) {
                this.adBreakDataReceivedObservable.notifyObservers(adBreakUpdate);
            }
        }
    ]);
    return BaseSsaiAdBreaksProvider;
}();

//# sourceMappingURL=base-ssai-ad-breaks-provider.js.map